export default "__VITE_ASSET__DmQj1e4g__"